export const TENANT_ENDPOINTS = {
  TENANTS: '/api/portal-admin/tenants',
  CREATE: '/api/portal-admin/tenants',
  BY_ID: (tenantId: string) =>
    `/api/portal-admin/tenants/${encodeURIComponent(tenantId)}`,
  PRODUCTS: (tenantId: string) =>
    `/api/portal-admin/tenants/${encodeURIComponent(tenantId)}/products`,
  DELETE_ELIGIBILITY: (tenantId: string) =>
    `/api/portal-admin/tenants/${encodeURIComponent(tenantId)}/delete-eligibility`,
} as const;
